// extracted by mini-css-extract-plugin
module.exports = {"top_ad":"top_ad-3hOtEELv","main":"main-3372DkS6","passAd":"passAd-Qx0WDdC5","footer_ad":"footer_ad-1zWE6-sv"};